"use client";

import React, { useMemo } from "react";
import styles from "./CardItem.module.css";
import defaultImage from "../../assets/images/freeface.jpg";
import { MobileCustomerProfileTimeDto } from "../../services/shared/service-proxies/service-proxies";
import moment from "moment-jalaali";
import { DateTime } from "ts-luxon";
import { ReactComponent as StatusCirclePending } from "../../assets/icons/card-status-pending-icon-ligh.svg";
import { ReactComponent as StatusCircle } from "../../assets/icons/card-status-paied-icon-ligh.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/ClockIcon.svg";
import { ReactComponent as CartIcon } from "../../assets/icons/CartIcon.svg";

moment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

const CardItem: React.FC<{ data: MobileCustomerProfileTimeDto }> = ({ data }) => {
  const categories = useMemo(() => {
    return JSON.parse(localStorage.getItem("categories") || "[]");
  }, []);

  const partners = useMemo(() => {
    return JSON.parse(localStorage.getItem("partners") || "[]");
  }, []);

  const service = categories.find((c: any) => c.id === data.categoryId);
  const serviceTitle = service?.name ?? "خدمت ناشناس";

  const partner = partners.find((p: any) => p.id === data.partnerId);
  const stylistName = partner
    ? `${partner.firstname} ${partner.lastname}`
    : "آرایشگر ناشناس";

  const image = partner?.profile || defaultImage;

  // ✅ تاریخ شمسی و زمان فارسی‌شده
  const displayedDate = data.onDate
    ? moment(data.onDate.toString()).format("jD jMMMM") // ۲۰ فروردین
    : "نامشخص";

  const fromTime = DateTime.fromISO(data.fromTime).toFormat("HH:mm");
  const toTime = DateTime.fromISO(data.toTime).toFormat("HH:mm");

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.statusSection}>
          <span className={styles.statusText}>رزرو شده</span>

          <StatusCircle />
        </div>
      </div>

      <div className={styles.cardBody}>
        <img
          src={image}
          alt={stylistName}
          className={styles.cardImage}
          onError={(e) => {
            (e.target as HTMLImageElement).src = defaultImage;
          }}
        />
        <div className={styles.textContainer}>
          <h6 className={styles.title}>{serviceTitle}</h6>
          <p className={styles.subtitle}>{stylistName}</p>
        </div>
      </div>

      <div className={styles.cardFooter}>
        <div className={styles.timeContainer}>
          <span className={styles.timeText}>
            {fromTime} تا {toTime}
          </span>

          <ClockIcon className={styles.clockImage} />

        </div>
        <div className={styles.dateContainer}>
          <span className={styles.timeText}>{displayedDate}</span>
          <CartIcon className={styles.dateIcon}></CartIcon>
        </div>
      </div>
    </div>
  );
};

export default CardItem;
